import { supabase } from '../lib/supabase'

const columns = 'id, socio_id, categoria, consulta, estado, respuesta, respondido_at, created_at, cp_socios(nombres, apellido_paterno, apellido_materno, numero_socio)'
const FRIENDLY = 'No fue posible completar la operación. Intenta nuevamente.'

// RLS limita todo a admin/directiva de su organización; el filtro por organización es redundante pero explícito.
export async function obtenerConsultas(organizacionId, estado = 'todas') {
  let query = supabase.from('cp_consultas').select(columns).eq('organizacion_id', organizacionId).order('created_at', { ascending: false }).limit(200)
  if (estado !== 'todas') query = query.eq('estado', estado)
  const { data, error } = await query
  if (error) throw new Error(FRIENDLY)
  // Pendientes primero; dentro de cada grupo, la más reciente primero.
  return (data ?? []).sort((a, b) => (b.estado === 'pendiente') - (a.estado === 'pendiente'))
}

// respondido_por, respondido_at y estado los fija un trigger en la base a partir de auth.uid().
export async function responderConsulta(organizacionId, consultaId, respuesta) {
  const { data, error } = await supabase.from('cp_consultas').update({ respuesta }).eq('organizacion_id', organizacionId).eq('id', consultaId).select(columns).maybeSingle()
  if (error || !data) throw new Error('No fue posible guardar la respuesta.')
  return data
}

export async function cerrarConsulta(organizacionId, consultaId) {
  const { data, error } = await supabase.from('cp_consultas').update({ estado: 'cerrada' }).eq('organizacion_id', organizacionId).eq('id', consultaId).select(columns).maybeSingle()
  if (error || !data) throw new Error('No fue posible cerrar la consulta.')
  return data
}
